"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobsContract = void 0;
const core_1 = require("@ts-rest/core");
const applications_1 = require("./applications");
const offers_1 = require("./offers");
const recruitment_1 = require("./recruitment");
const c = (0, core_1.initContract)();
exports.JobsContract = c.router({
    applications: applications_1.ApplicationsContract,
    offers: offers_1.JobOffersContract,
    recruitment: recruitment_1.RecruitmentContract,
});
